export default __webpack_public_path__ + "static/media/Dentist Park- Ma.72bd4f80.png";